module.exports = __webpack_public_path__ + "static/media/work_order_icon.c1a883e6.svg";